import { Button, Form, Input, Modal, Select } from 'antd';

import type { ModelCreateWarehouseInventory } from '@app/api/WarehouseInventories';
import { Error403Unauthorized } from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { PF } from '@app/pages/Warehouses/Inventory/components/AddEditInventory/data';
import {
  useAddEditInventory,
  useAddEditInventoryEffects,
} from '@app/pages/Warehouses/Inventory/components/AddEditInventory/hooks';
import type { AddEditInventoryType } from '@app/pages/Warehouses/Inventory/components/AddEditInventory/types';

import '@pages/Warehouses/Inventory/components/AddEditInventory/styles/AddEditInventory.scss';

const { Item } = Form;
const { TextArea } = Input;

export const AddEditInventory: AddEditInventoryType = ({ mode }) => {
  const {
    form,
    disabledForm,
    onCancel,
    openDeleteModal,
    warehousesOptions,
    isDeleteOpen,
    onDelete,
    closeDeleteModal,
    inventoryDataHandler,
    onFinish,
    IsInventoryCreate,
    IsInventoryEdit,
    IsInventoryDelete,
  } = useAddEditInventory({ mode });

  useAddEditInventoryEffects({ inventoryDataHandler });

  if (!IsInventoryCreate && mode === 'add') {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  if (!IsInventoryEdit && mode === 'edit') {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <>
      <Form<ModelCreateWarehouseInventory>
        form={form}
        layout="horizontal"
        labelAlign="left"
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 10 }}
        className={`${PF}_form`}
        name={`${PF}_form`}
        initialValues={{ Name: '', Comment: '' }}
        disabled={disabledForm}
        onFinish={onFinish}
      >
        <Item
          name="WarehouseId"
          label="Склад"
          rules={[{ required: true, message: 'Выберите склад' }]}
        >
          <Select
            showSearch
            optionFilterProp="label"
            options={warehousesOptions}
            placeholder="Выберите склад"
            allowClear
            disabled={disabledForm || mode === 'edit'}
          />
        </Item>
        <Item name="Comment" label="Комментарий">
          <TextArea
            placeholder="Введите комментарий"
            rows={6}
            disabled={false}
          />
        </Item>

        <div className={`${PF}_buttons`}>
          <Button
            type="primary"
            htmlType="submit"
            className={`${PF}_buttons_item`}
            disabled={disabledForm}
            loading={disabledForm}
          >
            Сохранить
          </Button>
          <Button
            type="default"
            className={`${PF}_buttons_item`}
            onClick={onCancel}
            disabled={disabledForm}
          >
            Отменить
          </Button>
          {mode === 'edit' && IsInventoryDelete && (
            <Button
              danger
              className={`${PF}_buttons_item`}
              onClick={openDeleteModal}
              disabled={disabledForm}
            >
              Удалить
            </Button>
          )}
        </div>
      </Form>
      <Modal
        title="Удаление инвентаризации"
        open={isDeleteOpen}
        onCancel={closeDeleteModal}
        onOk={onDelete}
        okText="Удалить"
        cancelText="Отмена"
        okButtonProps={{
          danger: true,
          disabled: disabledForm,
          loading: disabledForm,
        }}
        cancelButtonProps={{ disabled: disabledForm }}
      >
        <p>Вы уверены, что хотите удалить эту инвентаризацию?</p>
      </Modal>
    </>
  );
};
